import { Link } from "react-router";
import { useDispatch } from "react-redux";
import { CargoMindsLogo } from "@/components/common/svgs";
import { useTheme } from "@/components/layout/useTheme";
import { protectedRoutes } from "@/routing";
import { useAreFeaturesUnlocked } from "@/auth/roles";
import { setSearchType, clearInputsForLoadboard } from "@/state/searchInputSlice";

export const HeaderLogo = ({ linkEnabled = true }) => {
    const { isDarkTheme } = useTheme();
    const dispatch = useDispatch();
    const featuresLocked = !useAreFeaturesUnlocked();

    if (!linkEnabled) {
        return <CargoMindsLogo dark={isDarkTheme} />;
    }

    return (
        <Link
            to={protectedRoutes[0].path}
            onClick={() => {
                if (featuresLocked) {
                    dispatch(setSearchType("loadboard"));
                    dispatch(clearInputsForLoadboard());
                }
            }}
        >
            <CargoMindsLogo dark={isDarkTheme} />
        </Link>
    );
};
